import { Flex, Strong, Text } from '@radix-ui/themes';
import { t } from 'i18next';
import { ITableNoData } from 'interfaces/tables/no-data';
import { CSSProperties, PropsWithChildren, useMemo } from 'react';
import useMiscStore from 'stores/use-misc-store';

interface IProps extends Partial<ITableNoData> {
  className?: string;
  vFlex?: boolean;
}

export const NoDataPlaceholder = (props: PropsWithChildren<IProps>) => {
  const flexStyle = useMemo<CSSProperties>(() => {
    if (props.vFlex) {
      return {
        position: 'absolute',
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
      };
    }

    return {
      height: '480px',
    };
  }, [props.vFlex]);

  return (
    <Flex
      className={props.className}
      style={flexStyle}
      direction="column"
      justify="center"
      align="center"
      gap="2"
    >
      <img
        className="select-none"
        src={useMiscStore.getState().getThemeImgPath('no-data.svg')}
        alt="no data in table"
        style={{
          width: '80%',
          maxWidth: '462px',
          height: 'auto',
        }}
      />

      <Text align="center" size="3">
        <Strong>{t(props.noDataHeader ?? 'common.no-data-to-display')}</Strong>
      </Text>

      <Text align="center">{t(props.noDataBody ?? 'common.no-data-msg')}</Text>

      {props.noDataButton}
    </Flex>
  );
};
